import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'KitFilter',
  pure: true,
})
export class KitsPipe implements PipeTransform {
  transform(items: any[], status_check: string[]): any[] {
    if (!items || !status_check) {
      return items;
    }

    if (status_check.length === 1 && status_check[0].toLowerCase() === 'all') {
      return items;
    }

    return items.filter((item: any) => {
      if (!item.Status) return false;
      return status_check.some(status =>
        status.toLowerCase() === item.Status.toLowerCase()
      );
    });
  }
}
